import React, { useState } from 'react'
import { Box, Divider, IconButton, Menu, Typography, } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu'
import HeaderMenuMobile from '../submodules/HeaderMenuMobile';


const MenuMain = (props) => {

  const [ anchorEl, setAnchorEl ] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        alt="Main Menu"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        aria-label="Main Menu"
        id="basic-button"
        onClick={handleClick}
        sx={{marginX: .5,}}
      >
        <MenuIcon color={!props.isAppBarHovered ? "white" : "black"} />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        disableScrollLock={true}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Box sx={{alignItems: "center", display: "flex", mb:1, px:2,}}>
          <Typography fontWeight={500} variant="h5">Explore</Typography>
          <Box sx={{display: "flex", flex: 1, justifyContent: "flex-end"}}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Divider />
        <HeaderMenuMobile />
      </Menu>
    </>
  )
}

export default MenuMain